<template>
  <div
    :class="$style.seeAllFeaturesCard"
  >
    <p :class="$style.seeAllDescription">
      {{ description }}
    </p>
    <FlatActionButton
      :action="handleSeeAllButtonClick"
      :buttonClass="['btnDefault', $style.seeAllButton]"
      :text="seeAllButtonText"
    />
  </div>
</template>

<script>
import CardMixin from 'client/components/FeaturedItemsCarousel/cards/CardMixin';
import FlatActionButton from 'client/components/Buttons/FlatActionButton.vue';

export default {
  name: 'SeeAllFeaturesCard',

  components: {
    FlatActionButton,
  },

  mixins: [CardMixin],

  data() {
    return {
      description: this.card.description,
      handleSeeAllButtonClick: this.card.handleSeeAllButtonClick,
      seeAllButtonText: this.card.seeAllButtonText || 'See All',
    };
  },
};
</script>

<style module>

@value (jcGrey200) from '~css/brand-colors.css';

.seeAllFeaturesCard {
  border: 1px solid jcGrey200;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  height: 180px;
  justify-content: space-between;
  min-width: 210px;
  padding: 20px;
  position: relative;
}

.seeAllFeaturesCard .seeAllDescription {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.2;
}

.seeAllFeaturesCard .seeAllButton {
  margin: 0 auto 25px;
  width: 106px;
}
</style>
